import DashboardIcon from "@material-ui/icons/Dashboard";
import CallIcon from "@material-ui/icons/Call";
import PersonIcon from "@material-ui/icons/Person";
import ShowChartIcon from "@material-ui/icons/ShowChart";
import GroupIcon from "@material-ui/icons/Group";
import InputIcon from "@material-ui/icons/Input";
import HistoryIcon from "@material-ui/icons/History";
import ReportIcon from "@material-ui/icons/Report";
import Supervisor from "@material-ui/icons/SupervisorAccount";


/*
usertype: 0 = admin only
usertype: 1 = admin/pm only
usertype: 2 = fwp only
usertype: 3 = both
*/

const dashRoutes = [
  {
    path: "/admin",
    name: "Admin",
    icon: Supervisor,
    usertype: 0
  },
  {
    path: "/projects",
    name: "Projects",
    icon: DashboardIcon,
    usertype: 1
  },
  {
    path: "/callform",
    name: "Make a call",
    icon: CallIcon,
    usertype: 2
  },
  {
    path: "/users",
    name: "Users",
    icon: PersonIcon,
    usertype: 1
  },
  {
    path: "/stats",
    name: "Stats",
    icon: ShowChartIcon,
    usertype: 1
  },
  {
    path: "/callreports",
    name: "Call Reports",
    icon: ReportIcon,
    usertype: 1
  },
  // {
  //   path: "/aboutus",
  //   name: "About Us",
  //   icon: GroupIcon,
  //   component: null,
  //   usertype: 1
  // },
  {
    path: "/logs",
    name: "Logs",
    icon: HistoryIcon,
    component: null,
    usertype: 2
  },
  {
    path: "/logout",
    name: "Logout",
    icon: InputIcon,
    component: null,
    usertype: 3
  }
];


export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx